// Narrowing helpers for the Helpdesk atoms.
//
// WHY THIS FILE EXISTS: the list DTO types both fields as plain strings —
// `TicketListRow.status: string` and `TicketListRow.priority: string` — while
// the detail DTO uses the unions (`Ticket.status: TicketStatus`). The atoms
// take the unions, so the queue has to narrow at the boundary.
//
// Narrowing lives here rather than at each call site (which is what
// EXAMPLE_StatusPill.tsx sketches inline) so the queue and the ticket header
// share one definition and cannot drift.
//
// These are NOT new contract types. types.ts is reused as-is per the module
// CLAUDE.md; nothing here is added to it.
import { TicketChannel, TicketPriority, TicketStatus } from '../types';

const TICKET_STATUSES: TicketStatus[] = ['new', 'open', 'pending', 'resolved', 'closed'];
const TICKET_PRIORITIES: TicketPriority[] = ['low', 'medium', 'high', 'urgent'];
const TICKET_CHANNELS: TicketChannel[] = ['web', 'portal', 'widget', 'email', 'api', 'integration'];

export function isTicketStatus(value: string | null | undefined): value is TicketStatus {
  return !!value && (TICKET_STATUSES as string[]).indexOf(value) !== -1;
}

export function isTicketPriority(value: string | null | undefined): value is TicketPriority {
  return !!value && (TICKET_PRIORITIES as string[]).indexOf(value) !== -1;
}

export function isTicketChannel(value: string | null | undefined): value is TicketChannel {
  return !!value && (TICKET_CHANNELS as string[]).indexOf(value) !== -1;
}
